import { render } from "./SprintSetting.vue?vue&type=template&id=147175ad&scoped=true"
import script from "./SprintSetting.vue?vue&type=script&lang=js"
export * from "./SprintSetting.vue?vue&type=script&lang=js"

import "./SprintSetting.vue?vue&type=style&index=0&id=147175ad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147175ad"]])

export default __exports__